import {useState} from 'react';
import {isItemStateCatalogueFF} from 'ff-common';
import {State} from '@synako/halitrek';
import {ItemCatalogue2Desc, LigneDePanierDesc} from 'api-types/ffconnect-hal';
import {useTranslation} from 'react-i18next';
import {SelectUnite} from '@/domains/panier/BuyProduct/SelectUnite';
import {ProduitBuyButton} from '@/domains/ligneProduit/ProduitBuyButton';
import {useSelectionParColis} from '../catalogue/useSelectionParColis';
import {StyleProps} from '@chakra-ui/react';
import {TextToastCommand} from 'ff-common/src/types/TextToastCommand';
import {ContextsComposant} from 'ff-common/src/types/ContextsComposant';

export const useBuyingBlocks = (
  textToast: TextToastCommand,
  context: ContextsComposant,
  itemState?: State<ItemCatalogue2Desc>,
  lignePanier?: State<LigneDePanierDesc>,
  onProductClick?: (code_article: string) => void,
  panier_id?: string,
) => {
  const {t} = useTranslation();
  const [tooltip, setTooltip] = useState<string | undefined>();
  const [bKey, setBKey] = useState<string>();
  const itemStateFF =
    itemState && isItemStateCatalogueFF(itemState) ? itemState : undefined;

  const [quantiteDisplay, setQuantiteDisplay] = useState(
    lignePanier?.data.quantite,
  );
  const {selectionParColis, setSelectionUnite} = useSelectionParColis(
    lignePanier,
    itemStateFF?.data.code,
    itemStateFF?.data.quantite_colis_entier,
    textToast,
  );

  const uniteQuantiteBlock = (props?: StyleProps) =>
    itemStateFF && (
      <SelectUnite
        ic={itemStateFF.data}
        value={selectionParColis ? 'colis' : 'unitaire'}
        onSelect={(unite) => {
          // Réinitialisation du tooltip avant chaque changement
          setTooltip(undefined);
          const ancienneQuantite = quantiteDisplay;
          setSelectionUnite(unite).then((event) => {
            if (!event) return;
            const nouvelleQuantite = event.data.data.ligne_de_panier.quantite;
            // Affiche le message si on passe en colis et que la quantité a changé
            if (unite === 'colis' && nouvelleQuantite !== ancienneQuantite) {
              setTooltip(
                t('toast.unite_switchee', {
                  quantite:
                    event.data.data.ligne_de_panier.quantite_en_colis_entier,
                }),
              );
            }
            setQuantiteDisplay(event.data.data.ligne_de_panier.quantite);
            setBKey(event.data.id);
          });
        }}
        {...props}
      />
    );
  const buyBlock = (
    props?: {
      somethingSubmitting?: boolean;
      afficher_bouton_liste?: boolean;
      texte?: string;
    } & StyleProps,
  ) =>
    itemStateFF && (
      <ProduitBuyButton
        key={bKey}
        lignePanier={lignePanier}
        itemState={itemStateFF}
        commande_en={selectionParColis ? 'colis' : 'unitaire'}
        quantiteDisplay={quantiteDisplay}
        context={context}
        setQuantiteDisplay={setQuantiteDisplay}
        tooltip={tooltip}
        setTooltip={setTooltip}
        onProductClick={onProductClick}
        panier_id={panier_id}
        {...props}
      />
    );

  return {
    uniteQuantiteBlock,
    buyBlock,
    commandeEnColis: selectionParColis,
  };
};
